import { CUSTOM_JSON_COMPONENT_TYPES } from '@apps/websiteCustomJsonComponents/config';
import { JsonDataBlobComponentFragment } from '@graphql/generated';
import React, { Suspense } from 'react';

type GuestJsonComponentWrapperProps = {
  jsonComponentData: JsonDataBlobComponentFragment;
};

export const GuestSiteCustomJsonComponentWrapper = (props: GuestJsonComponentWrapperProps) => {
  const { jsonComponentData } = props;
  const data = jsonComponentData.containerContent;

  // Find config directly from the array
  const config = CUSTOM_JSON_COMPONENT_TYPES.find(c => c.schemaUrl === data?.schemaUrl);

  if (!config) {
    return null;
  }

  const Component = config.guestSiteComponent;

  return (
    <Suspense fallback={null}>
      <Component
        {...props}
        data={data}
      />
    </Suspense>
  );
};
